import type { FaireProductEntity } from "../../entity_types/product";

export const p_kr94mcpxq3: FaireProductEntity = {
  token: "p_kr94mcpxq3",
  type: "product",
  name: "Crisp & Cozy Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/dc00048c3148dbfa2b451b6c484a428005390488085650baabdf294cd92c145b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0e4922b8c13aa5fa218ee6f559db0cc7695ac17d8f018c89192190484e50234e.jpeg",
    "https://cdn.faire.com/fastly/2958c89b6245f3c371805765de40729efbc125daaa161edb56e1b3d6acc4e646.jpeg",
    "https://cdn.faire.com/fastly/5f826e8831b9977938ac35647e91b19fe1e6e2d71e11f81bf5f25de37b2371c7.jpeg",
  ],
  priceDollars: 7,
  description:
    'Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a small connection. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes® bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes® have already been shared worldwide, sparking connection one small gesture at a time."""',
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:30.586Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
